import styled from 'styled-components';

import {dimensions} from '@stryd/react-ui';

export const FilterContainer = styled.div`
  position: relative;
  margin-right: 15px;
  @media screen and (max-width: ${dimensions.breakpoints.mobile}) {
    width: 100%;
    margin-right: 0;
  }
`;
